export default __webpack_public_path__ + "static/outline-stream-fe0c11f40cc9490b4a55aea7a6b9376b.svg";